import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { IHeatmapReportClient, HeatmapReportClient, HeatmapReportSettingsDto } from "app/ApiClient";
import { BASE_URL } from "const/baseUrl";
import { LoadingState } from "types";

const reportClient: IHeatmapReportClient = new HeatmapReportClient(BASE_URL);

export const fetchReportSettings = createAsyncThunk(
  "heatmapreport/getreportsettings",
  async (arg: { originProjectId: string, projectId:number, currentEnvironmentKey?: string }, thunkAPI) => {
    const reportSettings = await reportClient.getReportSettings(
      arg.originProjectId,
      arg.currentEnvironmentKey,
    );
    if (thunkAPI.signal.aborted) {
      throw new Error("Request aborted");
    }
    return { reportSettings, projectId: arg.projectId };
  },
);

export interface HeatmapReportSettingsState {
  reportSettings: HeatmapReportSettingsDto | null;
  errorMessage?: string;
  lastSuccessState?: {
    projectId: number;
  };
  loading: LoadingState;
}

const initialState: HeatmapReportSettingsState = {
  reportSettings: null,
  loading: LoadingState.idle,
};

const reportSettingsSlice = createSlice({
  name: "reportSettings",
  initialState: initialState,
  reducers: {
    resetReportSettingsState: (state) => {
      const { lastSuccessState } = state;
      return { ...initialState, lastSuccessState };
    },
    resetReportSettingsData: (state) => {
      state.reportSettings = null;
      state.errorMessage = "";
    },
    resetReportSettinsLoading: (state) => {
      state.loading = LoadingState.idle;
      state.errorMessage = "";
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchReportSettings.pending, (state) => {
      state.loading = LoadingState.pending;
    });

    builder.addCase(fetchReportSettings.fulfilled, (state, action) => {
      const { reportSettings, projectId } = action.payload;

      state.reportSettings = reportSettings;
      state.loading = LoadingState.succeed;

      if (projectId !== undefined) {
        state.lastSuccessState = {
          projectId,
        };
      }
    });
    builder.addCase(fetchReportSettings.rejected, (state, action) => {
      state.loading = LoadingState.failed;
      state.errorMessage = action.error.message;
    });
  },
});

export const { resetReportSettinsLoading, resetReportSettingsState, resetReportSettingsData } = reportSettingsSlice.actions;
export default reportSettingsSlice.reducer;
